import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames/bind';
import { Link } from 'react-router-dom';

import LogoutButton from '../LogoutButton';

import styles from './styles.scss';
import {isSessionUserPlatformAdmin} from "../../../selectors/users";
import {refreshLinks, toggleLinkExpansion} from "../../../actions/navbar";

const getLinkClasses = (link) => {

    const cx = classnames.bind(styles);

    return cx({
        'link': true,
        'link--has-children': link.children.length > 0
    });
};

const getChildLinkListClasses = (link) => {

    const cx = classnames.bind(styles);

    return cx({
        'child-link-list': true,
        'child-link-list--expanded': link.expanded
    });
};

const getChildLinkClasses = () => {

    const cx = classnames.bind(styles);

    return cx({
        'child-link': true
    });
};

const MenuLink = props => {

    if (!props.link) {
        return (
            <a
                href=""
                tabIndex={props.tabEnabled ? 0 : -1}
                onClick={(e) => {e.preventDefault(); props.onLinkToggle() }}
                className={props.className || styles['link']}
            >
                { props.children }
            </a>
        )
    }

    return (
        <Link
            tabIndex={props.tabEnabled ? 0 : -1}
            onClick={props.onClick}
            className={props.className || styles['link']}
            to={props.link}
        >
            { props.children }
        </Link>
    );
};

const MenuLinkList = props => {
    return props.links.map((link) => {
        return (
            <li key={link.id}>
                <MenuLink
                    className={getLinkClasses(link)}
                    tabEnabled={props.isMenuOpen}
                    onClick={props.onMenuItemClick}
                    onLinkToggle={props.onLinkToggle.bind(this, link.id)}
                    link={link.link}
                >
                    { link.name }
                </MenuLink>

                {link.children.length > 0 &&

                    <ul className={getChildLinkListClasses(link)}>
                        {link.children.map((childLink) => {
                            return (
                                <li key={childLink.id}>
                                    <MenuLink
                                        className={getChildLinkClasses(childLink)}
                                        tabEnabled={props.isMenuOpen && link.expanded}
                                        onClick={props.onMenuItemClick}
                                        link={childLink.link}
                                    >
                                        { childLink.name }
                                    </MenuLink>
                                </li>
                            )
                        })}
                    </ul>
                }
            </li>
        )
    });
};

class MobileMenu extends React.Component {

    componentDidMount() {

        this.props.refreshLinks(window.location.pathname, this.props.isLoggedIn, this.props.isPlatformAdmin);
    }

    _toggleLinkExpansion(linkId, event) {

        event.preventDefault();
        this.props.toggleLinkExpansion(this.props.links, linkId);
    }

    _getClassNames() {
        const cx = classnames.bind(styles);

        return cx({
            'menu': true,
            'menu--open': this.props.isOpen
        });
    }

    render() {

        return (
            <nav id="mobile-menu" aria-hidden={!this.props.isOpen} className={this._getClassNames()} aria-label="Main navigation menu">
                <ul>

                    <MenuLinkList
                        isMenuOpen={this.props.isOpen}
                        onMenuItemClick={this.props.onMenuItemClick}
                        onLinkToggle={this.props.toggleLinkExpansion.bind(this, this.props.links)}
                        links={this.props.links}
                    />

                    {this.props.isLoggedIn &&
                        <li>
                            <LogoutButton className={styles['link']} onClick={this.props.onMenuItemClick}>
                                Logout
                            </LogoutButton>
                        </li>
                    }

                </ul>
            </nav>
        )
    }
}

MobileMenu.defaultProps = {
    isOpen: false
};

function mapStateToProps(state) {
    return {
        isLoggedIn: !!state.session.user,
        isPlatformAdmin: isSessionUserPlatformAdmin(state),
        links: state.navbar.links
    }
}

function mapDispatchToProps(dispatch) {
    return {
        refreshLinks(pathname, isLoggedIn, isPlatformAdmin) {
            dispatch(refreshLinks(pathname, isLoggedIn, isPlatformAdmin));
        },
        toggleLinkExpansion(links, linkId) {
            dispatch(toggleLinkExpansion(links, linkId));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);